import {
  Avatar,
  Checkbox,
  FormControlLabel,
  FormHelperText,
  Grid,
  IconButton,
  TextField,
  Typography,
} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import FormControl from "@material-ui/core/FormControl";
import Link from "@material-ui/core/Link";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import Slide from "@material-ui/core/Slide";
import { makeStyles } from "@material-ui/core/styles";
import AssignmentIcon from "@material-ui/icons/Assignment";
import GetAppIcon from "@material-ui/icons/GetApp";
import React, { useEffect } from "react";
import {
  IsNullOrEmpty,
  validEmail,
  validPhone,
  validURL,
} from "../../helpers/utility";
import FileDrop from "../base/FileDrop";
var countryjson = require("../../assets/country.json");

export default function EditUser(props) {
  const useStyles = makeStyles((theme) => ({
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
      width: "100%",
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    centerIcon: {
      fontSize: 40,
    },
    table: {
      width: "100%",
      textAlign: "left",
    },
    address: {
      lineHeight: 2,
      paddingLeft: theme.spacing(2),
    },
    title: {
      position: "absolute",
      left: theme.spacing(2),
    },
    product: {
      backgroundColor: theme.palette.info.main,
      color: "#FFFFFF",
    },
    avathar: {
      backgroundColor: theme.palette.info.main,
      color: "#FFFFFF",
    },
    item: {
      margin: 10,
      float: "right",
    },
  }));
  const classes = useStyles();

  const [info, setInfo] = React.useState({
    tenantName: null,
    tenantWebsite: null,
    tenantPhone: null,
    address: null,
    country: undefined,
    region: undefined,
    zipCode: null,
    city: null,
    files: [],
    isAgreed: false,
    primaryContactName: null,
    primaryContactEmail: null,
    primaryContactPhone: null,
    secondaryContactName: null,
    secondaryContactEmail: null,
    secondaryContactPhone: null,
    formSubmitted: false,
    DepositCommision: 1,
    WithdrawCommision: 1,
    whitelistIP: "",
    isDepositBatched: false,
    isWithdrawBatched: false,
    coolingPeriod: -1,
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInfo({ ...info, [name]: value });
  };

  useEffect(() => {
    if (props.user) {
      setInfo({
        tenantName: props.user.tenantName,
        tenantWebsite: props.user.tenantWebsite,
        tenantPhone: props.user.tenantPhone,
        address: props.user.address,
        country: props.user.country,
        region: props.user.region,
        zipCode: props.user.zipCode,
        city: props.user.city,
        files: props.user.documents,
        isAgreed: true,
        primaryContactName: props.user.primaryContactName,
        primaryContactEmail: props.user.primaryContactEmail,
        primaryContactPhone: props.user.primaryContactPhone,
        secondaryContactName: props.user.secondaryContactName,
        secondaryContactEmail: props.user.secondaryContactEmail,
        secondaryContactPhone: props.user.secondaryContactPhone,
        formSubmitted: true,
        DepositCommision: props.user.DepositCommision,
        WithdrawCommision: props.user.WithdrawCommision,
        whitelistIP: props.user.whitelistIP,
        isDepositBatched: props.user.isDepositBatched,
        isWithdrawBatched: props.user.isWithdrawBatched,
      });
    }
  }, [props.user]);

  const isValid = () => {
    return (
      !IsNullOrEmpty(info.tenantName) &&
      !IsNullOrEmpty(info.tenantWebsite) &&
      !IsNullOrEmpty(info.tenantPhone) &&
      !IsNullOrEmpty(info.address) &&
      !IsNullOrEmpty(info.country) &&
      !IsNullOrEmpty(info.region) &&
      !IsNullOrEmpty(info.city) &&
      !IsNullOrEmpty(info.zipCode) &&
      !IsNullOrEmpty(info.primaryContactName) &&
      !IsNullOrEmpty(info.primaryContactEmail) &&
      !IsNullOrEmpty(info.primaryContactPhone) &&
      !IsNullOrEmpty(info.secondaryContactName) &&
      !IsNullOrEmpty(info.secondaryContactEmail) &&
      !IsNullOrEmpty(info.secondaryContactPhone) &&
      info.files.length > 0 &&
      info.isAgreed
    );
  };

  const saveInfo = () => {
    if (isValid()) {
      let data = {
        id : props.user.id,
        tenantName: info.tenantName,
        tenantWebsite: info.tenantWebsite,
        tenantPhone: info.tenantPhone,

        primaryContactName: info.primaryContactName,
        primaryContactEmail: info.primaryContactEmail,
        primaryContactPhone: info.primaryContactPhone,

        secondaryContactName: info.secondaryContactName,
        secondaryContactEmail: info.secondaryContactEmail,
        secondaryContactPhone: info.secondaryContactPhone,

        address: info.address,
        country: info.country,
        region: info.region,
        zipCode: info.zipCode,
        city: info.city,

        whitelistIP: info.whitelistIP,
        coolingPeriod: info.coolingPeriod,

        DepositCommision: info.DepositCommision,
        WithdrawCommision: info.WithdrawCommision,

        isDepositBatched: info.isDepositBatched,
        isWithdrawBatched: info.isWithdrawBatched,

        documents: info.files,
      };
      props.onSave(data);
    } else {
      setInfo({ ...info, formSubmitted: true });
    }
  };

  const handleCheckChange = (event) => {
    setInfo({ ...info, isAgreed: event.target.checked });
  };

  let countryList = countryjson.countries.map((x) => {
    return x.country;
  });

  let stateList = [];

  if (!IsNullOrEmpty(info.country)) {
    let temp = countryjson.countries.filter((x) => {
      return x.country === info.country;
    });
    stateList = temp[0].states;
  }
  const preventDefault = (event) => event.preventDefault();

  if (!props.user || !props.user.id) {
    return <></>;
  }

  return (
    <Dialog
      className="model-left-position"
      open={props.open}
      maxWidth="lg"
      onClose={() => props.onClose()}
      TransitionComponent={Slide}
      aria-labelledby="form-dialog-title"
      transitionDuration={500}
      TransitionProps={{
        direction: "right",
      }}
    >
      <DialogTitle id="alert-dialog-slide-title">Edit Customer</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item md={4}>
            <TextField
              variant="outlined"
              label="Tenant Name"
              fullWidth
              error={info.formSubmitted && IsNullOrEmpty(info.tenantName)}
              helperText={
                info.formSubmitted && IsNullOrEmpty(info.tenantName)
                  ? "Tenant Name Cannot be Empty"
                  : ""
              }
              name="tenantName"
              value={info.tenantName}
              onChange={handleInputChange}
            />
          </Grid>
          <Grid item md={4}>
            <TextField
              variant="outlined"
              label="Tenant Domain"
              error={info.formSubmitted && !validURL(info.tenantWebsite)}
              helperText={
                info.formSubmitted && !validURL(info.tenantWebsite)
                  ? "Tenant Website Name is not valid"
                  : ""
              }
              fullWidth
              name="tenantWebsite"
              value={info.tenantWebsite}
              onChange={handleInputChange}
            />
          </Grid>
          <Grid item md={4}>
            <TextField
              variant="outlined"
              label="Tenant Contact #"
              error={info.formSubmitted && !validPhone(info.tenantPhone)}
              helperText={
                info.formSubmitted && !validPhone(info.tenantPhone)
                  ? "Tenant Contact # is not valid"
                  : ""
              }
              fullWidth
              name="tenantPhone"
              value={info.tenantPhone}
              onChange={handleInputChange}
            />
          </Grid>
          <Grid item md={4}>
            <TextField
              variant="outlined"
              label="Address"
              error={info.formSubmitted && IsNullOrEmpty(info.address)}
              helperText={
                info.formSubmitted && IsNullOrEmpty(info.address)
                  ? "Address Cannot be Empty"
                  : ""
              }
              fullWidth
              multiline
              rows={6}
              name="address"
              value={info.address}
              onChange={handleInputChange}
            />
          </Grid>
          <Grid item md={4}>
            <FormControl fullWidth variant="outlined">
              <Select
                name="country"
                value={info.country}
                onChange={handleInputChange}
                error={info.formSubmitted && IsNullOrEmpty(info.country)}
                fullWidth
                labelId="demo-simple-select-label"
                id="demo-simple-select"
              >
                <MenuItem value={undefined}>Select Country</MenuItem>
                {countryList.map((x) => {
                  return <MenuItem value={x}>{x}</MenuItem>;
                })}
              </Select>
              <FormHelperText
                error={info.formSubmitted && IsNullOrEmpty(info.country)}
              >
                {info.formSubmitted && IsNullOrEmpty(info.country)
                  ? "Country Cannot be Empty"
                  : ""}
              </FormHelperText>
            </FormControl>
            <br />
            <br />
            <FormControl fullWidth variant="outlined">
              <Select
                fullWidth
                labelId="demo-simple-select-label"
                error={info.formSubmitted && IsNullOrEmpty(info.region)}
                id="demo-simple-select"
                name="region"
                value={info.region}
                onChange={handleInputChange}
              >
                <MenuItem value={undefined}>Select Region</MenuItem>
                {stateList.map((x) => {
                  return <MenuItem value={x}>{x}</MenuItem>;
                })}
              </Select>
              <FormHelperText
                error={info.formSubmitted && IsNullOrEmpty(info.region)}
              >
                {info.formSubmitted && IsNullOrEmpty(info.region)
                  ? "Region Cannot be Empty"
                  : ""}
              </FormHelperText>
            </FormControl>
          </Grid>
          <Grid item md={4}>
            <TextField
              variant="outlined"
              label="City"
              error={info.formSubmitted && IsNullOrEmpty(info.city)}
              helperText={
                info.formSubmitted && IsNullOrEmpty(info.city)
                  ? "City Should not be Empty"
                  : ""
              }
              fullWidth
              name="city"
              value={info.city}
              onChange={handleInputChange}
            />
            <br />
            <br />
            <TextField
              variant="outlined"
              label="Zip Code"
              error={info.formSubmitted && IsNullOrEmpty(info.zipCode)}
              helperText={
                info.formSubmitted && IsNullOrEmpty(info.zipCode)
                  ? "Zipcode Cannot be Empty"
                  : ""
              }
              fullWidth
              name="zipCode"
              value={info.zipCode}
              onChange={handleInputChange}
            />
          </Grid>
          <Grid item md={4}>
            <TextField
              variant="outlined"
              label="Primary Contact Name"
              error={
                info.formSubmitted && IsNullOrEmpty(info.primaryContactName)
              }
              helperText={
                info.formSubmitted && IsNullOrEmpty(info.primaryContactName)
                  ? "Name Cannot be Empty"
                  : ""
              }
              fullWidth
              name="primaryContactName"
              value={info.primaryContactName}
              onChange={handleInputChange}
            />
          </Grid>
          <Grid item md={4}>
            <TextField
              variant="outlined"
              label="Primary Contact Email"
              error={
                info.formSubmitted && !validEmail(info.primaryContactEmail)
              }
              helperText={
                info.formSubmitted && !validEmail(info.primaryContactEmail)
                  ? "Email is not valid"
                  : ""
              }
              fullWidth
              name="primaryContactEmail"
              value={info.primaryContactEmail}
              onChange={handleInputChange}
            />
          </Grid>
          <Grid item md={4}>
            <TextField
              variant="outlined"
              label="Primary Contact Phone"
              error={
                info.formSubmitted && !validPhone(info.primaryContactPhone)
              }
              helperText={
                info.formSubmitted && !validPhone(info.primaryContactPhone)
                  ? "Phone # is not valid"
                  : ""
              }
              fullWidth
              name="primaryContactPhone"
              value={info.primaryContactPhone}
              onChange={handleInputChange}
            />
          </Grid>
          <Grid item md={4}>
            <TextField
              variant="outlined"
              label="Secondary Contact Name"
              error={
                info.formSubmitted && IsNullOrEmpty(info.secondaryContactName)
              }
              helperText={
                info.formSubmitted && IsNullOrEmpty(info.secondaryContactName)
                  ? "Name Cannot be Empty"
                  : ""
              }
              fullWidth
              name="secondaryContactName"
              value={info.secondaryContactName}
              onChange={handleInputChange}
            />
          </Grid>
          <Grid item md={4}>
            <TextField
              variant="outlined"
              label="Secondary Contact Email"
              error={
                info.formSubmitted && !validEmail(info.secondaryContactEmail)
              }
              helperText={
                info.formSubmitted && !validEmail(info.secondaryContactEmail)
                  ? "Email is not valid"
                  : ""
              }
              fullWidth
              name="secondaryContactEmail"
              value={info.secondaryContactEmail}
              onChange={handleInputChange}
            />
          </Grid>
          <Grid item md={4}>
            <TextField
              variant="outlined"
              label="Secondary Contact Phone"
              error={
                info.formSubmitted && !validPhone(info.secondaryContactPhone)
              }
              helperText={
                info.formSubmitted && !validPhone(info.secondaryContactPhone)
                  ? "Phone # is not valid"
                  : ""
              }
              fullWidth
              name="secondaryContactPhone"
              value={info.secondaryContactPhone}
              onChange={handleInputChange}
            />
          </Grid>
          <Grid item md={4}>
            <TextField
              variant="outlined"
              label="Deposit Commission"
              error={info.formSubmitted && IsNullOrEmpty(info.DepositCommision)}
              helperText={
                info.formSubmitted && IsNullOrEmpty(info.DepositCommision)
                  ? "Deposit Commision Cannot be Empty"
                  : ""
              }
              fullWidth
              name="DepositCommision"
              value={info.DepositCommision}
              onChange={handleInputChange}
            />
          </Grid>
          <Grid item md={4}>
            <TextField
              variant="outlined"
              label="Withdraw Commission"
              error={
                info.formSubmitted && IsNullOrEmpty(info.WithdrawCommision)
              }
              helperText={
                info.formSubmitted && IsNullOrEmpty(info.WithdrawCommision)
                  ? "Withdraw Commision Cannot be Empty"
                  : ""
              }
              fullWidth
              name="WithdrawCommision"
              value={info.WithdrawCommision}
              onChange={handleInputChange}
            />
          </Grid>
          <Grid item md={4}>
            <TextField
              variant="outlined"
              label="whitelist IP"
              error={info.formSubmitted && IsNullOrEmpty(info.whitelistIP)}
              helperText={
                info.formSubmitted && IsNullOrEmpty(info.whitelistIP)
                  ? "whitelist IP Cannot be Empty"
                  : ""
              }
              fullWidth
              name="whitelistIP"
              value={info.whitelistIP}
              onChange={handleInputChange}
            />
          </Grid>
          <Grid item md={4}>
            <FormControlLabel
              control={
                <Checkbox
                  name="isDepositBatched"
                  checked={info.isDepositBatched}
                  onChange={(event) =>
                    setInfo({ ...info, isDepositBatched: event.target.checked })
                  }
                />
              }
              label={"Deposit Batched"}
            />
          </Grid>
          <Grid item md={4}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={info.isWithdrawBatched}
                  name="isWithdrawBatched"
                  onChange={(event) =>
                    setInfo({
                      ...info,
                      isWithdrawBatched: event.target.checked,
                    })
                  }
                />
              }
              label={"Withdraw Batched"}
            />
          </Grid>
          {info.files.length === 0 ? (
            <Grid item md={12}>
              <Typography variant="p" component="b">
                Upload Documents
              </Typography>
              <br />
              <br />
              <FileDrop
                containerName="kyc"
                canUpload={info.isAgreed}
                onUpload={(files) => setInfo({ ...info, files: files })}
                items={[
                  "PAN Card",
                  "Aadhar Card",
                  "Voter Id",
                  "Driving License",
                  "Cancelled Cheque",
                  "Bank Passbook",
                  "Passport",
                  "Contract Document",
                  "Company's PAN",
                ]}
              />
            </Grid>
          ) : (
            <List>
              {info.files.map((x) => {
                return (
                  <ListItem>
                    <ListItemAvatar>
                      <Avatar>
                        <AssignmentIcon />
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText primary={x.value} secondary={x.id} />
                    <ListItemSecondaryAction>
                      <Link
                        href={x.url}
                        rel="noopener noreferrer"
                        target="_blank"
                        onClick={preventDefault}
                      >
                        <IconButton edge="end" aria-label="delete">
                          <GetAppIcon />
                        </IconButton>
                      </Link>
                    </ListItemSecondaryAction>
                  </ListItem>
                );
              })}
            </List>
          )}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => saveInfo()} variant="contained" color="primary">
          Save
        </Button>
        <Button
          onClick={() => props.onClose()}
          variant="outlined"
          color="primary"
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
}
